





























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
	ConsentConditionTypeModule,
	ConsentCouncil,
	ConsentModule,
	OrgsModule,
	WaterExportModule,
} from '@/modules';
import { ConsentWithId, Product } from '@/api';
import Toast from '@/components/display/toast.vue';
import WaterConsentSettings from '@/components/display/water-consents/water-consent-settings.vue';
import WaterConsentConditions from '@/components/display/water-consents/water-consent-conditions.vue';
import WaterConsentExports from '@/components/display/water-consents/water-consent-exports.vue';
import InformationRow from '@/components/display/information-row.vue';

@Component({
	components: {
		InformationRow,
		WaterConsentExports,
		WaterConsentConditions,
		WaterConsentSettings,
	},
})
export default class WaterConsentOverview extends Vue {
	private readonly toast: Toast = new Toast();
	private readonly consentModule: ConsentModule = new ConsentModule();

	@Prop()
	public product?: Product | null;

	protected consentOptions: {
		text: string;
		value: ConsentWithId & ConsentCouncil & { active?: boolean; consentconditions?: any[] };
	}[] = [];
	protected consent?:
		| (ConsentWithId & ConsentCouncil & { active?: boolean; consentconditions?: any[] })
		| null = null;

	public async mounted() {
		if (this.product?.id == null) {
			this.toast.makeToast('No product ID found', 'Error Loading Consents', 'danger');
			return;
		}

		await this.onReloadConsents();
	}

	protected async onReloadConsents(): Promise<void> {
		if (this.product?.id == null) return;

		const consents = await this.consentModule.getConsentsForProduct(this.product.id);
		this.consentOptions = consents.map(c => ({
			text: `ID: ${c.id} (Identifier: ${c.consentIdentifier})`,
			value: c,
		}));
		if (consents?.length >= 1) {
			this.consent = consents[0];

			if (this.consent?.consentconditions)
				this.consent.consentconditions.sort((a: any, b: any) => a.id - b.id);
		} else if (consents.length === 0) {
			this.consent = {
				productId: this.product.id,
				active: false,
			};
		}
	}
}
